/** @format */

import {
   ABR_VIEW,
   BREAKDOWN_VIEW,
   LIVE_CAPTIONS_VIEW,
   DOC_VIEW,
   H5LIVE_VIEW,
   HISTORY_VIEW,
   HOME_VIEW,
   MOQ_VIEW,
   QOE_VIEW,
   TROUBLESHOOTING_VIEW,
   MISUSE_VIEW,
   WEBRTC_VIEW,
   WORLD_VIEW,
   LOGOUT_VIEW,
} from '../../constants/general';
import { AccessLevel } from '../../constants/AccessLevels';

export const navItems = [
   {
      name: 'Home',
      url: `/${HOME_VIEW}`,
      icon: 'bi bi-speedometer adjust-i-size',
      level: AccessLevel.BASIC,
   },
   {
      name: 'Break down',
      url: `/${BREAKDOWN_VIEW}`,
      icon: 'bi bi-speedometer adjust-i-size',
      level: AccessLevel.BASIC,
   },
   {
      name: 'Live captions',
      url: `/${LIVE_CAPTIONS_VIEW}`,
      icon: 'bi bi-badge-cc adjust-i-size',
      level: AccessLevel.FULL,
   },
   {
      name: 'World map',
      url: `/${WORLD_VIEW}`,
      icon: 'bi bi-speedometer adjust-i-size',
      level: AccessLevel.BASIC,
   },
   {
      name: 'H5Live',
      url: `/${H5LIVE_VIEW}`,
      icon: 'bi bi-speedometer adjust-i-size',
      level: AccessLevel.FULL,
   },
   {
      name: 'MOQ',
      url: `/${MOQ_VIEW}`,
      icon: 'bi bi-speedometer adjust-i-size',
      level: AccessLevel.FULL,
   },
   {
      name: 'Adaptive bitrate',
      url: `/${ABR_VIEW}`,
      icon: 'bi bi-speedometer adjust-i-size',
      level: AccessLevel.FULL,
   },
   {
      name: 'Quality of experience',
      url: `/${QOE_VIEW}`,
      icon: 'bi bi-speedometer adjust-i-size',
      level: AccessLevel.ADMIN,
   },
   {
      name: 'Webcaster',
      url: `/${WEBRTC_VIEW}`,
      icon: 'bi bi-speedometer adjust-i-size',
      level: AccessLevel.FULL,
   },
   {
      name: 'Historical usage',
      url: `/${HISTORY_VIEW}`,
      icon: 'bi bi-clock-history adjust-i-size',
      level: AccessLevel.FULL,
   },
   {
      name: 'Troubleshooting',
      url: `/${TROUBLESHOOTING_VIEW}`,
      icon: 'bi bi-tools adjust-i-size',
      level: AccessLevel.FULL,
   },
   {
      name: 'Guardian',
      url: `/${MISUSE_VIEW}`,
      icon: 'bi bi-tools adjust-i-size',
      level: AccessLevel.BASIC,
   },
   {
      name: 'Documentation',
      url: `/${DOC_VIEW}`,
      icon: 'bi bi-journal-text adjust-i-size',
      level: AccessLevel.NONE,
   },
   {
      name: 'Logout',
      url: `/${LOGOUT_VIEW}`,
      icon: 'bi bi-box-arrow-right adjust-i-size',
      level: AccessLevel.NONE,
   },
];
